import React from 'react';

const Unauthorized = () => {
    return (
        <div className="max-w-xl mx-auto mt-20 flex flex-col items-center px-4">
            <h1 className="text-lg font-semibold mb-4 text-center">
                Sie verfügen nicht über die Berechtigung, diesen Inhalt zu sehen
            </h1>
            <p className="text-center text-gray-700">
                Sie verfügen nicht über die erforderlichen Berechtigungen, um auf diese Seite zuzugreifen.
                Bitte wenden Sie sich an den Administrator, falls Sie glauben, dass es sich um einen Fehler handelt.
            </p>
        </div>
    );
};

export default Unauthorized;
